// extracted by mini-css-extract-plugin
module.exports = {"root":"SocialLockup_root__2t4VT","item":"SocialLockup_item__2pmo5","icon":"SocialLockup_icon__7Vypw"};